<template>
  <div class="">
    <permissions> </permissions>
  </div>
</template>

<script>
import Permissions from "@/components/profile/permissions/users/permissions.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    Permissions,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: `Modifica Permessi :: ${this.$route.params.user.username}`,
        path: "users.edit2",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: `Modifica Permessi :: ${this.$route.params.user.username}`,
        path: "users.edit2",
        level: 3,
      });
    }
  },
};
</script>
